var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotif24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 15.9953,
    viewBox: "0 0 16 15.9953",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 169"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 7.99756H8C3.58176 7.99756 0 11.5782 0 15.9952H8C12.4182 15.9952 16 12.4145 16 7.99756Z",
    fill: "#D6A102"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16 7.99767H8.00001C3.58177 7.99767 7.58267e-06 4.41698 7.58267e-06 0H8.00001C12.4182 0 16 3.58068 16 7.99767Z",
    fill: "#274766"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotif24);
export default __webpack_public_path__ + "static/media/motif-24.f9fa4d1cae21dde62298e6ae002db549.svg";
export { ForwardRef as ReactComponent };